import { cn } from '@worldcoo/ui/lib/utils';
import { Image } from '../../-components/image';

/**
 * Mirrors the donors app's `CampaignNgos`
 * (`apps/donors/src/routes/-components/campaign-detail.tsx`): a small rounded-square
 * logo chip followed by the NGO name, sitting above the campaign title.
 *
 * Used on mobile in place of the "A campaign from:" card, which spends a lot of
 * vertical space on logos alone. The only deviation from donors is the border token
 * (`border-border` instead of `border-border-alt`, which is the donors cream palette)
 * and the use of the portal `Image` so the logo goes through the CDN like every other
 * portal image.
 */
export function CampaignNgosInline(props: {
	ngos: {
		id: string;
		name?: string;
		logo?: { location: string; width: number; height: number };
	}[];
	className?: string;
}) {
	const ngos = props.ngos
		.filter((ngo) => ngo.name ?? ngo.logo)
		// Same ordering as the desktop card so both views list the NGOs alike.
		// There is not a wide support for toSorted() in the browser
		// oxlint-disable-next-line unicorn/no-array-sort
		.sort((a, b) => a.name?.localeCompare(b.name ?? '') ?? 0);

	if (ngos.length === 0) return null;

	return (
		<div className={cn('flex flex-wrap items-center gap-x-6 gap-y-2', props.className)}>
			{ngos.map((ngo) => (
				<div key={ngo.id} className="flex items-center gap-2">
					{ngo.logo ? (
						<Image
							src={ngo.logo.location}
							alt={ngo.name ?? ''}
							height={32}
							aspectRatio={ngo.logo.width / ngo.logo.height}
							objectFit="contain"
							className="border-border size-8 shrink-0 rounded-lg border bg-white object-contain!"
						/>
					) : (
						<div className="border-border bg-secondary size-8 shrink-0 rounded-lg border" />
					)}
					<span className="font-medium">{ngo.name}</span>
				</div>
			))}
		</div>
	);
}
